import { useContext } from "react";
import { LanguageContext } from "../provider";

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
      throw new Error('useLanguage must be used within a LangProvider');
    }
    return context;
  };

export default useLanguage